export const FORM_LOCAL_STORAGE_KEY = "@Home/form-data";
export const PACKAGE_MODE_FLAG_KEY = "quero-caju-package-mode";